var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrevArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.182,
    height: 14.121,
    viewBox: "0 0 9.182 14.121",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "prevarrow",
    d: "M0,12,6,6,0,0",
    transform: "translate(1.061 1.061) scale(-1, 1)",
    "transform-origin": "center",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: "3px"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrevArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/prev-arrow.80518d76bd2f469b1cf96ff7bcd4e260.svg";